// extracted by mini-css-extract-plugin
export default {"accordion":"Disclosure_accordion__Mh8ln","disclosureMarkdown":"Disclosure_disclosureMarkdown__4THBF"};